// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__fZWFp","icon":"SortAdornment_icon__1Wjyk","up":"SortAdornment_up__mzkLT","down":"SortAdornment_down__k3WzB","active":"SortAdornment_active__2DVMR"};